import AuthedHeader from '@/components/headers/AuthedHeader.vue'
import TCRouter from '@/views/typing-center/router.vue'
import TCDashboard from '@/views/typing-center/dashboard/index.vue'
import TCRequests from '@/views/typing-center/requests/index.vue'
import TCPayments from '@/views/typing-center/payments/index.vue'
import TCRequestsForPayment from '@/views/typing-center/requests-for-payment/index.vue'

export default [
  {
    path: '/typing-center',
    name: 'TCLanding',
    meta: { needsAuth: true },
    components: {
      navbar: AuthedHeader,
      default: TCRouter
    },
    children: [
      {
        path: '',
        name: 'TCDashboard',
        components: {
          default: TCDashboard
        }
      },
      {
        path: 'requests',
        name: 'TCRequests',
        component: TCRequests
      },
      {
        path: 'payments',
        name: 'TCPayments',
        component: TCPayments
      },
      {
        path: 'requests-for-payment',
        name: 'TCRequestsForPayment',
        component: TCRequestsForPayment
      }
    ]
  }
]
